import React from 'react';
import PropTypes from 'prop-types';

import FormWrapper from 'components/requirements/form_wrapper';
import { requirementShape } from 'components/requirements/types';
import RequirementsForm from './requirements_form';

export default class RequirementsFormContainer extends React.Component {
  static propTypes = {
    createPath: PropTypes.string.isRequired,
    googleMapsApiKey: PropTypes.string.isRequired,
    investmentTypes: PropTypes.array.isRequired,
    parentPath: PropTypes.string.isRequired,
    propertyTypes: PropTypes.array.isRequired,
    propertyUses: PropTypes.arrayOf(
      PropTypes.shape({ id: PropTypes.number, label: PropTypes.string })
    ).isRequired,
    requirement: requirementShape,
    stateOptions: PropTypes.array.isRequired,
    transactionTypes: PropTypes.array.isRequired
  }

  render() {
    return (
      <FormWrapper
        {...this.props}
        formComponent={RequirementsForm}
        parentType="Profile"
      />
    );
  }
}
